import { Grid } from "@mui/material"
import { Link, useNavigate } from "react-router-dom"
import { Logo, TelegramIcon, XIcon } from "../assets"
import { socialLinks } from "./commons"

const Footer = () => {
  const history = useNavigate()
  // const location = useLocation()

  const navigateTo = (route: string) => {
    history(route)
  }

  // const isDefaultPath = location.pathname !== '/markets' && location.pathname !== '/rewards'
  return (
    <Grid container sx={{
      color: 'white', backgroundColor: 'background.primary',
      padding: '0rem 2rem',
      alignItems: 'center',
      marginTop: '8rem',
      borderTop: '1px solid',
      borderColor: 'background.border',
      bottom: 0,
      width: '100%',
      position: 'absolute'
    }}>
      <Grid item container xs={6}>
        <Link to={socialLinks.twitter} target='_blank' style={{ display: 'grid', placeSelf: 'center' }}>
          <XIcon style={{ writingMode: 'vertical-lr', width: '2rem', height: '1.5rem' }} />
        </Link>
        <Link to={socialLinks.telegram} target='_blank' style={{ display: 'grid', placeSelf: 'center' }}>
          <TelegramIcon style={{ writingMode: 'vertical-lr', marginLeft: '1rem', marginTop: '0.25rem' }} />
        </Link>
      </Grid>
      <Grid item container justifyContent={"flex-end"} xs={6}>
        <Logo style={{ maxWidth: '6rem', maxHeight: '3rem' }} onClick={() => navigateTo('')} />
      </Grid>
      {/* <div style={{ display: 'flex', gap: '1rem' }}>
        <Button onClick={() => navigateTo('')} size='large' variant='text' isSelected={location.pathname === '/' || isDefaultPath} sx={{ border: 0 }}> Portfolio </Button>
        <Button onClick={() => navigateTo('/markets')} size='large' variant='text' sx={{ border: 0 }} isSelected={location.pathname === '/markets'}> Markets </Button>
        <Button onClick={() => navigateTo('/rewards')} size='large' variant='text' sx={{ border: 0 }} isSelected={location.pathname === '/rewards'}> Rewards </Button>
      </div> */}
    </Grid>
  )
}

export default Footer